import React from 'react';
import CalendlyButton from './CalendlyButton';

const pricingPlans = [
  {
    title: 'Pack Essentiel',
    description: 'Diagnostic stratégique pour optimiser vos communications LinkedIn.',
    features: [
      'Audit complet des performances LinkedIn (quantitatif et qualitatif)',
      'Analyse des forces et faiblesses des contenus publiés',
      'Recommandations stratégiques clés',
      'Rapport PDF livré sous 7 jours + session de présentation',
    ],
    highlight: false,
  },
  {
    title: 'Pack Avancé',
    description: 'Accompagnement stratégique complet du Codir (jusqu’à 5 collaborateurs).',
    features: [
      'Diagnostic & analyse avancée des KPI',
      'Benchmarking sectoriel ou concurrents',
      'Recommandations pour aligner LinkedIn avec les objectifs business',
      'Formation de base (1 session incluse)',
      'Rapport PDF sous 14 jours + session de présentation virtuelle',
    ],
    highlight: true,
  },
  {
    title: 'Pack Premium',
    description: 'Accompagnement sur-mesure pour grands comptes (6+ collaborateurs).',
    features: [
      'Analyse continue des KPI LinkedIn',
      'Diagnostic et mise en place d’un plan stratégique',
      'Recommandations personnalisées',
      'Benchmarking avancé',
      'Formation (2 sessions incluses)',
      'Rapport PDF sous 21 jours + présentation',
    ],
    highlight: false,
  },
];

const PricingWithCTA = () => {
  return (
    <>
      {/* Pricing Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10">
            Nos offres d’accompagnement
          </h2>
          <div className="grid md:grid-cols-3 gap-8 items-stretch">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`flex flex-col justify-between rounded-xl shadow-md p-6 ${
                  plan.highlight ? 'bg-blue-50 border border-blue-400' : 'bg-white'
                }`}
              >
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">{plan.title}</h3>
                  <p className="text-gray-600 mb-4">{plan.description}</p>
                  <ul className="text-sm text-gray-700 space-y-2">
                    {plan.features.map((feat, i) => (
                      <li key={i} className="flex items-start">
                        <span className="text-green-600 mr-2">✔</span>
                        {feat}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-6">
                  <CalendlyButton
                    className="w-full rounded-md bg-gray-800 text-white py-2 hover:bg-gray-900 transition"
                    text="Demander un devis"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-blue-600 py-16 text-white text-center rounded-t-3xl">
        <div className="container mx-auto px-4">
          <h4 className="text-sm font-medium mb-2">Besoin d’un conseil personnalisé ?</h4>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Réservez un appel avec notre équipe
          </h2>
          <p className="mb-6 max-w-2xl mx-auto">
            Nous analysons votre présence LinkedIn et vous proposons des leviers concrets pour booster votre stratégie B2B.
          </p>
          <CalendlyButton
             className="inline-block bg-grey text-blue-600 font-semibold py-3 px-6 rounded-lg hover:bg-blue-100 transition"
              text="Prendre rendez-vous"
          />
        </div>
      </section>
    </>
  );
};

export default PricingWithCTA;
